
let x = 0;

export function text55_viewportEnter(event) {
    if(x === 0){
     $w('#post1').getPost()
     .then( (post) => {
     let postTitle = post.title;
     $w("#text55").text = $w("#text55").text + postTitle;
                      } )
    }
    x = 1;
}
